import React from "react";
import {Tooltip} from "@mantine/core";

export const CarzelleTooltip = React.memo(({children, message, width, allowHtml = false}) => {
    if (!message) {
        return children;
    }

    // If allowHtml is true and message contains HTML tags, render as JSX
    const tooltipLabel = allowHtml && typeof message === 'string' && message.includes('<') 
        ? <div dangerouslySetInnerHTML={{ __html: message }} />
        : message;

    return (
        <Tooltip label={tooltipLabel} arrowSize={8} multiline w={width} openDelay={500} withArrow>
            {children}
        </Tooltip>
    )
})